var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pageWithHeaderBody userBackground layout-column" },
    [
      _c(
        "div",
        {
          staticClass: "DocumentView Vertical",
          class: _vm.$style.documentView,
        },
        [
          _vm.isChainOrTmc ? _c("SideNav") : _vm._e(),
          _c("div", { staticClass: "DocumentViewContainer" }, [
            _c(
              "div",
              { class: _vm.$style.accountProfileContainer },
              [
                _vm.activeModuleComponent
                  ? _c(_vm.activeModuleComponent, {
                      tag: "component",
                      class: {
                        [_vm.$style.accountProfileContent]: true,
                        [_vm.$style.withNav]: _vm.isChainOrTmc,
                      },
                      attrs: {
                        state: _vm.state,
                        "user-account": _vm.userAccount,
                        "is-admin": _vm.isAdmin,
                        account: _vm.account,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }